import React from 'react';
import ReactDOM from 'react-dom/client';
import StudioRoot from './StudioRoot';
import './styles.css';
import './translationStyles.css';
import './polishStyles.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode><StudioRoot/></React.StrictMode>
);
